import GooglePlay from 'app/icons/Custom/AppBadges/GooglePlay';
import Clickable from 'atoms/Clickable/Clickable';
import React from 'react';

const GooglePlayBadge = (): JSX.Element => (
  <Clickable
    display='flex'
    href='https://play.google.com/store/apps/details?id=com.mightybell.mb&hl=en_US'
  >
    <GooglePlay />
  </Clickable>
);

export default GooglePlayBadge;
